import { ISiteMetaTags } from '@llws/lift-entity-interfaces';

import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/website-api/site_meta_tags';
const listViewName: string = '';
const showLogging: boolean = false;

export const siteHasMetaTags = 'shmt';
export const defaultFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'site',
      alias: siteHasMetaTags,
    },
  ],
};
const defaultGetListFilters: IQueryCommandOptions = defaultFilters;
const defaultGetSingleFilters: IQueryCommandOptions = defaultFilters;

const base = new StoreBaseImplementationV2<ISiteMetaTags>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced, // 'site_meta_tags'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
